import BaseComponent, { BaseComponentProps } from './BaseComponent';
import { LoaderMode } from './types';

export type CircleLoaderProps = Omit<BaseComponentProps, 'mode' | 'value'>;

const CircleLoader: React.FC<CircleLoaderProps> = (props) => (
    <BaseComponent mode={LoaderMode.Indeterminate} data-test-circle-loader {...props} />
);

export default CircleLoader;
